module.exports = __webpack_public_path__ + "img/Rectangle66.70cfeebb.png";